<template>
  <v-layout justify-center>
    <v-flex xs12 sm6 md8 class="mt-2">
      <v-toolbar color="white" dark>
        <v-toolbar-title class="red--text">Subscription Plans</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          dark
          class="no-uppercase v-btn--large bg-blue white--text v-btn--round"
          v-if="showComparison == false"
          @click="showComparison = true"
        >
          compare packages
        </v-btn>
      </v-toolbar>
      <div>
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          :top="y === 'top'"
        >
          {{ errorMsg }}
          <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <div class="text-xs-center">
        <v-dialog v-model="dialog" width="500">
          <v-card v-if="packageInfo">
            <v-card-title class="headline lighten-2 project" primary-title>
              {{ packageInfo.name }} Package
            </v-card-title>
            <v-card-text>
              <p class="text-h4 text--primary"><b>Package Features</b></p>
              <v-divider class="mb-2"></v-divider>
              <p
                v-for="(
                  packageServiceInfo, index1
                ) in packageInfo.package_detail"
                :key="index1"
              >
                {{ index1 + 1 }}. {{ packageServiceInfo.service_name }} ({{
                  getAllowedLimit(packageServiceInfo)
                }})
              </p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div class="text-xs-center">
        <v-dialog v-model="dialog1" width="800">
          <v-card width="600px">
            <v-card-title class="project">
              <div><span class="headline">Make a Payment</span></div>
              <v-spacer></v-spacer>
              <!-- <v-btn color="blue darken-2 text-none" small dark @click="back"
                >Back
              </v-btn> -->
            </v-card-title>

            <v-card-text>
              <!-- <p class="text-md-center display-1">Your Total Budget: {{budget.total_budget_amount}} Tk.</p> -->
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Package Name:</v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ subscription_pack.package_name }}
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Package Duration:</v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ subscription_pack.duration }} Month
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Start Date:</v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ subscriptionStartDate() }}
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title">End Date:</v-subheader>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{
                      subscriptionEndDate(subscription_pack.subscription_end_at)
                    }}
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="black--text title"
                    >Subscription Fee:</v-subheader
                  >
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="black--text headline">
                    {{ subscription_pack.package_price }} Taka
                  </v-subheader>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" flat @click="dialog1 = false">
                Close
              </v-btn>
              <v-spacer></v-spacer>

              <router-link
                v-if="isLoggedIn"
                style="text-decoration: none"
                :to="{
                  name: 'Subscription Payment Page',
                  params: { subscription_pack: subscription_pack },
                }"
                ><v-btn class="button text-none" flat :disabled="clicked"
                  >Pay Now</v-btn
                ></router-link
              >
              <v-btn
                v-if="!isLoggedIn"
                class="button text-none"
                flat
                @click="signin"
                >SignIn</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <template>
        <v-tabs centered color="red" dark icons-and-text>
          <v-tabs-slider color="white"></v-tabs-slider>

          <v-tab href="#tab-1"> Monthly </v-tab>

          <v-tab href="#tab-2"> Half-yearly </v-tab>

          <v-tab href="#tab-3"> Yearly </v-tab>

          <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
            <v-card flat v-if="indexData.packages">
              <!-- <v-card-text>{{ text }}</v-card-text> -->
              <v-card>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex
                      v-for="packageData in getPackageData(i)"
                      :key="packageData.id"
                      v-bind="{ [`xs${i == 1 ? 4 : 6}`]: true }"
                    >
                      <v-card class="mx-auto">
                        <v-card-title class="mb-0 pb-0">
                          <span
                            class="headline red--text pb-0 font-weight-bold"
                            v-text="packageData.name"
                          >
                          </span>
                        </v-card-title>
                        <v-card-text class="pt-1">
                          <h4 class="pb-2 title font-weight-regular">
                            <span v-if="packageData.id == 1">🎯</span>
                            <span v-if="packageData.id == 2">💎</span>
                            <span v-if="packageData.id == 3">👑</span>
                            {{ priceFromPackage(packageData, i) }} Taka
                          </h4>

                          <v-divider class="mb-2"></v-divider>
                          <div v-if="packageData.id == 1">
                            <p><span>5 Survey Creation Per Month</span></p>
                            <p>
                              <span
                                >100 Responses Allowed Per Survey Per
                                Month</span
                              >
                            </p>
                            <p><span>10 Questions Per Survey Allowed</span></p>
                            <p><span>1 User Allowed</span></p>
                            <p><span>Response Download Allowed</span></p>
                          </div>
                          <div v-if="packageData.id == 2">
                            <p><span>10 Survey Creation Per Month</span></p>
                            <p>
                              <span
                                >1000 Responses Allowed Per Survey Per
                                Month</span
                              >
                            </p>
                            <p><span>5 Respondent Filter Allowed</span></p>
                            <p><span>3 Users Allowed</span></p>
                            <p><span>200 Questions Per Survey</span></p>
                          </div>
                          <div v-if="packageData.id == 3">
                            <p><span>30 Survey Creation Per Month</span></p>
                            <p>
                              <span
                                >5000 Responses Allowed Per Survey Per
                                Month</span
                              >
                            </p>
                            <p><span>10 Respondent Filter Allowed</span></p>
                            <p><span>5 Users Allowed</span></p>
                            <p><span>Analytics Visualization Allowed</span></p>
                          </div>
                          <!-- <p
                            v-for="(
                              packageService, index
                            ) in packageData.package_detail"
                            :key="index"
                          >
                            <span v-if="index < 5">
                              {{ index + 1 }}.
                              {{ packageService.service_name }} ({{
                                getAllowedLimit(packageService)
                              }})</span
                            >
                          </p> -->
                        </v-card-text>
                        <!-- <v-card-actions>
                          <v-btn
                            flat
                            variant="text"
                            round
                            color="teal-accent-4"
                            @click="viewPackageData(packageData)"
                          >
                            View More
                          </v-btn>
                        </v-card-actions> -->

                        <v-card-actions class="pt-0">
                          <v-btn
                            round
                            variant="text"
                            color="red"
                            :disabled="!getSubscription(packageData.id)"
                            @click="subscribe(i, packageData)" class="white--text"
                          >
                            subscribe
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </template>
      <v-flex sm12 xs12 md12 class="mb-2" v-show="showComparison">
        <PackageComparison @hide="hideComparison($event)" />
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import PackageComparison from "../../components/PackageComparison.vue";
import DemoRequest from "../../components/DemoRequest.vue";
import router from "@/router";
export default {
  components: {
    PackageComparison,
    // DemoRequest,
  },
  data: () => ({
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    dialog: false,
    clicked: false,
    dialog1: false,
    packageInfo: null,
    showComparison: false,
    subscription_pack: {
      package_name: "",
      package_id: "",
      package_price: "",
      duration: "",
      subscription_start_at: "",
      subscription_end_at: "",
    },
    max_array: [1, 2, 4, 6, 7, 19, 20, 21, 22],

    // text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    hasSubscription() {
      if (this.subscriptionData.subscriptionPlan) {
        return true;
      }
      return false;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    checkShowComparison(e) {
      this.showComparison = e;
    },
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", ["package-info"]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    subscriptionStartDate() {
      if (this.hasSubscription) {
        if (this.subscriptionData.subscriptionPlan.package_id > 1) {
          return this.subscriptionData.subscriptionPlan.end_date;
        }
        return this.subscriptionData.subscriptionPlan.start_date;
      }
      return this.currentDate();
    },
    addMonths(date, months) {
      date.setMonth(date.getMonth() + months);
      return date;
    },
    subscriptionEndDate(date_value) {
      var date = new Date();
      // console.log(this.subscriptionData.subscriptionPlan.end_date);
      if (this.subscriptionData.subscriptionPlan) {
        let month = "";
        let year = "";
        let day = "";
        let newDate = "";
        if (this.subscriptionData.subscriptionPlan.package_id > 1) {
          date = new Date(this.subscriptionData.subscriptionPlan.end_date);
          newDate = this.addMonths(date, this.subscription_pack.duration);
          year = newDate.toLocaleString("default", { year: "numeric" });
          month = newDate.toLocaleString("default", { month: "2-digit" });
          day = newDate.toLocaleString("default", { day: "2-digit" });
          return year + "-" + month + "-" + day;
        } else {
          date = new Date();
          newDate = this.addMonths(date, this.subscription_pack.duration);
          year = newDate.toLocaleString("default", { year: "numeric" });
          month = newDate.toLocaleString("default", { month: "2-digit" });
          day = newDate.toLocaleString("default", { day: "2-digit" });
          return year + "-" + month + "-" + day;
        }
      }
      // if (this.subscriptionData.subscriptionPlan.package_id == 3) {
      //   return this.subscriptionData.subscriptionPlan.end_date;
      // }
      return date_value;
    },
    compare() {
      router.push("/package-comparison");
    },
    hideComparison(e) {
      this.showComparison = false;
      // console.log(this.showComparison);
      // console.log(e);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    getPackageData(value) {
      if (value > 1) {
        // return this.indexData.packages.data;
        return this.indexData.packages.data.filter((r) => r.id !== 1);
      }
      return this.indexData.packages.data;
    },
    payNow() {
      // this.dialog=true
      router.push("/subscriptionPayment-method");
    },
    getDuration(value) {
      var duration = 1;
      if (value == 1) {
        duration = 1;
      } else if (value == 2) {
        duration = 6;
      } else {
        duration = 12;
      }
      return duration;
    },

    priceFromPackage(packageData, index) {
      var result = packageData.package_price.find(
        (element) => element.duration === this.getDuration(index)
      );

      if (result) {
        return result.price.toLocaleString("en-US");
      } else {
        return "0";
      }
    },
    signin() {
      router.push("/signin");
    },
    viewPackageData(value) {
      this.packageInfo = value;
      this.dialog = true;
    },
    currentDate() {
      var current = new Date();
      var year = current.toLocaleString("default", { year: "numeric" });
      var month = current.toLocaleString("default", { month: "2-digit" });
      var day = current.toLocaleString("default", { day: "2-digit" });

      return year + "-" + month + "-" + day;
    },
    endDate(duration) {
      var currentDate = "";
      if (this.hasSubscription) {
        if (this.subscriptionData.subscriptionPlan.package_id > 1) {
          currentDate = new Date(
            this.subscriptionData.subscriptionPlan.end_date
          );
        } else {
          currentDate = new Date();
        }
      } else {
        currentDate = new Date();
      }

      var newCurrent = new Date(
        currentDate.setMonth(currentDate.getMonth() + parseInt(duration))
      );
      var end_year = newCurrent.toLocaleString("default", {
        year: "numeric",
      });
      var end_month = newCurrent.toLocaleString("default", {
        month: "2-digit",
      });
      var end_day = newCurrent.toLocaleString("default", { day: "2-digit" });
      return end_year + "-" + end_month + "-" + end_day;
    },

    subscribe(value, value1) {
      // console.log(value1);
      this.packageInfo = value1;
      this.subscription_pack.package_name = value1.name;
      this.subscription_pack.package_id = value1.id;
      this.subscription_pack.package_price = this.priceFromPackage(
        value1,
        value
      );
      this.subscription_pack.duration = this.getDuration(value);
      this.subscription_pack.subscription_start_at =
        this.subscriptionStartDate();
      this.subscription_pack.subscription_end_at = this.endDate(
        this.subscription_pack.duration
      );
      this.dialog1 = true;
    },
    getSubscription(value) {
      if (!this.isLoggedIn) {
        return true;
      }

      let package_id = parseInt(value);
      if (this.subscriptionData < 0) {
        return true;
      }

      let currentPackage_id = this.subscriptionData.subscriptionPlan.package_id;

      if (package_id == 1) {
        return false;
      } else if (
        package_id != currentPackage_id &&
        this.subscriptionData.subscriptionPlan.is_active == 1
      ) {
        if (package_id === currentPackage_id) {
          return true;
        } else if (package_id != currentPackage_id && currentPackage_id == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    getAllowedLimit(serviceDetail) {
      if (this.max_array.includes(serviceDetail.service_id)) {
        return serviceDetail.max_limit;
      } else {
        return "yes";
      }
    },

    proceed() {
      this.$store.dispatch("store", [
        "subscription-plan",
        this.subscription_pack,
      ]);
      setTimeout(() => {
        this.dialog1 = false;
        this.snackbar = true;
        this.close();
        this.$store.dispatch("setIndexData", ["package-info"]);
        // router.push("/");
      }, 400);
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.pay-button {
  font-size: 16px;
  background: #1565c0;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.hr {
  margin-top: 20px;
}
</style>
